import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { createURL } from '@jwp/ott-common/src/utils/urlFormatting';
import placeHolderImage from '@jwp/ott-theme/assets/profiles/placeholder_img.png';
import styles from './Image.module.scss';

type Props = {
  className?: string;
  image?: string;
  onLoad?: () => void;
  alt?: string;
  width?: number | string;
  handleError?: () => void;
};

type ImageState = {
  src: string | null;
  onThor: boolean;
};

const setWidth = (url: string, width: number | string) => {
  return createURL(url, { width });
};

const Image = ({ className, image, onLoad, alt = '', width = 640, handleError }: Props) => {
  const [imgUrl, setImageUrl] = useState<ImageState>({
    src: image ? setWidth(image, width) : null,
    onThor: false,
  });

  useEffect(() => {
    if (image) {
      const finalUrl = setWidth(image, width);
      setImageUrl((prevState) => ({
        ...prevState,
        onThor: false,
        src: finalUrl,
      }));
    } else {
      setImageUrl((prevState) => ({
        ...prevState,
        src: null,
      }));
    }
  }, [image, width]);

  const handleLoad = () => {
    if (onLoad) onLoad();
  };

  const handleErrorInternal = () => {
    if (handleError) handleError();
    setImageUrl((prevState) => ({
      ...prevState,
      src: placeHolderImage,
      onThor: true,
    }));
  };

  if (!imgUrl.src) return null;

  return (
    <div className={classNames(imgUrl.onThor ? styles.imageContainers : styles.imageContainer, className)}>
      <img
        className={imgUrl?.onThor ? styles.placeHolder : typeof width !== 'string' ? styles.image : styles.image_fill}
        src={imgUrl.src}
        onLoad={handleLoad}
        alt={alt}
        onError={handleErrorInternal}
      />
    </div>
  );
};

export default React.memo(Image);
